angular.module('app.filters').filter('bytes', () => {
  'ngInject';
  return function (bytes, precision) {
    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
    if (typeof precision === 'undefined') precision = 1;
    if (bytes == 0) return '0 B';
    var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'],
      number = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
  };
});

angular.module('app.filters').filter('bits', () => {
  'ngInject';
  return function (bytes, precision, part = 'all') {
    var value, suffix;
    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
      value = '-';
      suffix = '';
    } else {
      if (typeof precision === 'undefined') {
        precision = 1;
      }
      if (bytes == 0) {
        value = 0;
        suffix = 'b';
      } else {
        var units = ['b', 'kb', 'Mb', 'Gb', 'Tb', 'Pb'],
          number = Math.floor(Math.log(bytes) / Math.log(1024));
        value = (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision);
        suffix = units[number];
      }
    }
    if (part == 'value') {
      return value;
    } else if (part == 'suffix') {
      return suffix;
    } else {
      return `${value} ${suffix}`;
    }
  };
});



// WEBPACK FOOTER //
// ./app/filters/bytes.js